import React from 'react';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import type { Blocker } from 'react-router-dom';
import { useModalContainer } from '../../../contexts/ModalContainerContext';
import { GANTT_LEAVE_CONFIRM_Z_INDEX } from '../../schedule-tasks/components/GanttLeaveConfirmModal';

interface LocationDraftLeaveConfirmModalProps {
  blocker: Blocker;
  onConfirmLeave?: () => void | Promise<void>;
}

export function LocationDraftLeaveConfirmModal({
  blocker,
  onConfirmLeave,
}: LocationDraftLeaveConfirmModalProps) {
  const modalContainer = useModalContainer();
  const isBlocked = blocker.state === 'blocked';

  const handleStay = () => {
    if (blocker.state === 'blocked') {
      blocker.reset();
    }
  };

  const handleLeave = async () => {
    if (blocker.state === 'blocked') {
      await onConfirmLeave?.();
      blocker.proceed();
    }
  };

  return (
    <Modal
      opened={isBlocked}
      onClose={handleStay}
      title="Discard unsaved changes?"
      centered
      closeOnClickOutside={false}
      zIndex={GANTT_LEAVE_CONFIRM_Z_INDEX}
      portalProps={modalContainer ? { target: modalContainer } : undefined}
    >
      <Stack gap="md">
        <Text size="sm">
          You have unsaved location changes. If you leave now, your edits will be lost.
        </Text>
        <Text size="sm" c="dimmed">
          Use <strong>Save changes</strong> on the location page to persist your work before leaving.
        </Text>
        <Group justify="flex-end" gap="sm" mt="xs">
          <Button variant="default" onClick={handleStay}>
            Stay here
          </Button>
          <Button variant="filled" color="red" onClick={handleLeave}>
            Leave without saving
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
